import globalActions from "../api/GlobalActions.js"
import globalMutations from "../api/GlobalMutations.js"
import globalGetters from "../api/GlobalGetters.js"

export const state = () => ({
  isStale: true,
  latest_fetch: "",
  type: "notes",
  canEdit: false,
  canView: false,
  effectedByYear: false,
  yearFields: [],
  modelLabels: {
    single: "Note",
    plural: "Notes"
  },
  filterOverrides: ["audits"],
  aliasField: "title",
  relations: [
    {
      name: "audits",
      translate: "audits",
      label: "Audits",
      value: "audits",
      storename: "audits",
      yearFields: [],
      export: false
    },
    {
      name: "contact",
      translate: "contact",
      label: "Contact",
      value: "contacts",
      storename: "contacts",
      yearFields: []
    },
    {
      name: "user",
      translate: "user",
      label: "User",
      value: "users",
      storename: "users",
      yearFields: []
    }
  ],
  all: {},
  reference: {
    /* for showing paginated resources ... needs a bit more work. */
  },
  active: false,
  page: 1,
  pageCount: 0,
  pagination: {
    groupBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
    itemsPerPage: 100,
    sort: false,
    sortBy: "name",
    page: 1,
    sortDesc: []
  },
  total: 0,
  print_path: "",
  print: false,
  export: false,
  search: null,
  searchFields: ["title", "body"],
  bound: {},
  filter: {},
  quickFilters: [],
  stub: {
    audits: [],
    contact: {},
    author: {}
  },
  // members are called contractors on the server
  include: "audits",
  headers: {},
  notifications: {}
})

// Mutations ==================

export const mutations = {
  ...globalMutations
}

// Actions ====================

export const actions = {
  ...globalActions
}

// Getters ====================

export const getters = {
  ...globalGetters
}
